/**
 * 
 * Use this file to get data from the window
 * 
 * MVC will add initial data to the window object
 * 
 */

import * as signalR from "@microsoft/signalr";
import type { Pinia } from 'pinia';
import type { App } from 'vue';

import { AppStudioSentry, type AppStudioSentryOptions } from './Sentry/app-studio-sentry';

declare global {
    interface Window {
        appStudioSentryOptions?: AppStudioSentryOptions;
        softools: SoftoolsWindow;
    }
}

export interface SoftoolsWindow {
    requestVerificationToken: string;
    signalRConnection?: signalR.HubConnection;
    signalRConnectionId: string;
    pinia?: Pinia;
    appIdentifier: string;
    controller?: string;
    configureVueApp(app: App): void;

    /**
     * Dispatch this event to trigger a refetch of Publish Status Info used in Navbar Publish Button/ Publish Banner Alert.
     * (We do not have a single root Vue Instance - otherwise we could have used state management e.g. Vuex)
     */
    reloadAppPublishStatusInfoEvent: Event;
}

export class SOF implements SoftoolsWindow {
    public requestVerificationToken = '';
    public signalRConnection?: signalR.HubConnection;
    public signalRConnectionId = '';
    public pinia?: Pinia;
    public appIdentifier = '';
    public reloadAppPublishStatusInfoEvent = new Event('reloadapppublishstatusinfo');

    public configureVueApp(app: App): void {
        appStudioSentry.configureVueApp(app);
    }
}

const appStudioSentry = new AppStudioSentry();
appStudioSentry.initialize(window.appStudioSentryOptions);

export const sof = new SOF();

window.softools = sof;
